import { render, staticRenderFns } from "./ShowContent.vue?vue&type=template&id=007b43c6&scoped=true&"
import script from "./ShowContent.vue?vue&type=script&lang=js&"
export * from "./ShowContent.vue?vue&type=script&lang=js&"
import style0 from "./ShowContent.vue?vue&type=style&index=0&id=007b43c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b43c6",
  null
  
)

export default component.exports